import { Type } from '@sinclair/typebox';
// POST /ai/generate (non-streaming — when `stream: true`, the response is
// chunked text and bypasses JSON schema validation via reply.hijack()).
export const GenerateBodySchema = Type.Object({
    // trackId is REQUIRED so every generation is budget-gated and metered (S12).
    trackId: Type.String({ format: 'uuid' }),
    // M27 task-04 (ADM-05; HUB-082): OPTIONAL. A registered `internal_name`, a
    // literal `provider:model` (Estimates back-compat), or omitted → the
    // `ai_generate` purpose assignment. Resolution lives in routes/ai.ts.
    model: Type.Optional(Type.String({ minLength: 1 })),
    messages: Type.Array(Type.Object({
        role: Type.Union([
            Type.Literal('system'),
            Type.Literal('user'),
            Type.Literal('assistant'),
        ]),
        content: Type.String(),
    }), { minItems: 1 }),
    system: Type.Optional(Type.String()),
    maxOutputTokens: Type.Optional(Type.Integer({ minimum: 1 })),
    temperature: Type.Optional(Type.Number({ minimum: 0, maximum: 2 })),
    stream: Type.Optional(Type.Boolean()),
});
export const TokenUsageSchema = Type.Object({
    inputTokens: Type.Optional(Type.Number()),
    outputTokens: Type.Optional(Type.Number()),
    totalTokens: Type.Optional(Type.Number()),
});
export const GenerateResponseSchema = Type.Object({
    text: Type.String(),
    usage: TokenUsageSchema,
    finishReason: Type.Optional(Type.String()),
});
// POST /ai/embed — `model` is optional; falls back to EMBEDDING_MODEL_ID on the hub.
export const EmbedBodySchema = Type.Object({
    model: Type.Optional(Type.String({ minLength: 1 })),
    values: Type.Array(Type.String(), { minItems: 1 }),
});
export const EmbedResponseSchema = Type.Object({
    embeddings: Type.Array(Type.Array(Type.Number())),
    usage: TokenUsageSchema,
});
// POST /ai/chunk — `chunkSize` is optional; falls back to CHUNK_SIZE on the hub.
export const ChunkBodySchema = Type.Object({
    text: Type.String({ minLength: 1 }),
    chunkSize: Type.Optional(Type.Integer({ minimum: 1 })),
});
export const ChunkSchema = Type.Object({
    text: Type.String(),
    tokenCount: Type.Integer({ minimum: 0 }),
    startChar: Type.Integer({ minimum: 0 }),
    endChar: Type.Integer({ minimum: 0 }),
});
export const ChunkResponseSchema = Type.Object({
    chunks: Type.Array(ChunkSchema),
    chunkSize: Type.Integer({ minimum: 1 }),
});
//# sourceMappingURL=ai.js.map